import { Injectable, Signal, computed, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PathService {
  public currentPath: Signal<string>;
  public inMenu: Signal<boolean>;
  public isInPrintReceipt: Signal<boolean>;
  public isInQrPayment: Signal<boolean>;

  constructor() {
    const router = inject(Router);

    this.currentPath = toSignal(
      router.events.pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        map((event) => event.urlAfterRedirects),
        distinctUntilChanged(),
      ),
      { initialValue: "" },
    );

    this.inMenu = computed(() => this.currentPath().includes("/menu"));
    this.isInPrintReceipt = computed(() =>
      this.currentPath().includes("/printReceipt"),
    );

    this.isInQrPayment = computed(() => {
      this.currentPath();

      let route = router.routerState.root;
      while (route) {
        if (route.snapshot.data["isQrPayment"]) {
          return true;
        }
        route = route.firstChild!;
      }
      return false;
    });

    effect(() => {
      if (this.isInPrintReceipt()) {
        document.documentElement.style.setProperty(
          "--main-pages-offset",
          "0px",
        );
      }
    });
  }
}
